import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@state-mgmt/store';
import { Client } from '@mytypes/client';

export const useGetClient = () => {
  const { clients } = useSelector((state: RootState) => state.client);
  return useCallback((clientId: string): Client | undefined => clients.find(client => client.id === clientId), [clients]);
};
